// Func = limiting Scope for this file
var lastScrollTop = 0;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;


if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function getImageDimensions(url) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			resolve({ width: img.width, height: img.height });
		};
		img.onerror = (err) => {
			reject('Error loading image');
		};
		img.src = url;
	});
}

function responsiveTablet(){
	document.querySelectorAll('.js-responsive-tablet').forEach( element => {
		if(windowWidth < 1000){
			if(!element.classList.contains('changed')){
				element.classList.add('changed');
				element.src = element.dataset.tablet;
			}
		} else {
			if(element.classList.contains('changed')){
				element.classList.remove('changed');
				element.src = element.dataset.desktop;
			}
		}
	})
	
}

function checkPrimaryNavigation(){
	if(document.querySelector('.js-menu-container')){
		document.querySelector('.js-menu-container').querySelectorAll('a').forEach( link => {
			link.addEventListener('click', (e) => {
				if(link.nextElementSibling !== null && link.nextElementSibling.classList.contains('sub-sub-menu')){
					e.preventDefault();

					document.querySelector('.js-menu-container').querySelectorAll(':scope li').forEach( link => link.classList.remove('active'));
					link.closest('li').classList.add('active');
					
					//link.parentElement.classList.contains('active') ? link.parentElement.closest('li').classList.remove('active') : link.parentElement.closest('li').classList.add('active');
					//link.nextElementSibling.querySelector('.submenu').classList.add('open');
			
				}
			})
		});
	}
}

function resizeWindow(){
	windowWidth = window.innerWidth;
	windowHeight = window.innerHeight;


	responsiveTablet();
	

	if(windowWidth < 600){
		//responsive image:
		if(document.querySelectorAll('.js-responsive-img').length > 0){
			document.querySelectorAll('.js-responsive-img').forEach( img => {
				if(!img.classList.contains('changed')){
					img.classList.add('changed');
					img.src = img.dataset.mobile;
				}
			})
		}
		checkPrimaryNavigation();
	} else {
		//responsive image:
		if(document.querySelectorAll('.js-responsive-img').length > 0){
			document.querySelectorAll('.js-responsive-img').forEach( img => {
				if(img.classList.contains('changed')){
					img.classList.remove('changed');
					img.src = img.dataset.desktop;
				}
			})
		}
	}
}

(function(){



	window.addEventListener('resize', function() {
        resizeWindow();
	});
	resizeWindow();

	//track view menu
	document.querySelectorAll('a').forEach( link => {
		if(!link.dataset.section){
			if(link.textContent.toLowerCase().indexOf('menu') > -1){
				link.dataset.section = 'track-menu'
			}
		}
	})



	if(document.querySelectorAll('.btn').length > 0){
		document.querySelectorAll('.btn').forEach( btn => {
			setTimeout(() => {
				btn.setAttribute('data-text', btn.textContent);
				if(btn.querySelector('span') === null){
					let span = document.createElement('span');
					span.innerHTML = btn.innerHTML;
					btn.innerHTML = '';
					btn.appendChild(span);
					
				}
			}, 500);
		})
	}

	//accordion
	const accordionTitles = document.querySelectorAll('.js-accordion_title');

	if (accordionTitles.length > 0) {
			accordionTitles.forEach(title => {
					title.addEventListener('click', () => {
							title.classList.toggle('active');
							const content = title.nextElementSibling;
							content.classList.toggle('hidden');
							const isExpanded = title.getAttribute('aria-expanded') === 'true';
							title.setAttribute('aria-expanded', !isExpanded);
					});
					title.addEventListener('keydown', (e) => {
							if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									title.click();
							}
					});
			});
	}


	//cms form focus animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}
	if(document.querySelectorAll('.field').length > 0){
		document.querySelectorAll('.field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

	if(document.querySelector('.menus-block:not(.mobile)')){
		let tabsMenus = document.querySelectorAll('.menus-block__filter li');
		let allMenus = document.querySelectorAll('.menus-block_list .menu');
		let lastClickMenu = null;

		tabsMenus.forEach((tab)=>{
			tab.addEventListener('click',()=>{
				let dataMenu = tab.dataset.menu;
				if(lastClickMenu){
					lastClickMenu.classList.remove('active');
				}

				allMenus.forEach((menus)=>{
					menus.classList.toggle('hidden', menus.dataset.menu != dataMenu);
				})
				
				tab.classList.add('active');
				lastClickMenu = tab;
			})
		})
		tabsMenus[0].click();

		allMenus.forEach((menu)=>{
			let tabsCategories = menu.querySelectorAll('.menu__filter li');
			let allCategories = menu.querySelectorAll('.menu_category');
			let lastClickCategory = null;
			tabsCategories.forEach((tabCat)=>{
				tabCat.addEventListener('click',()=>{
					let dataCategory = tabCat.dataset.category;
					if(lastClickCategory){
						lastClickCategory.classList.remove('active');
					}

					allCategories.forEach((category)=>{
						category.classList.toggle('hidden', category.dataset.category != dataCategory);
					})

					tabCat.classList.add('active');
					lastClickCategory = tabCat;
					
				})
			});
			tabsCategories[0].click();
		})
	}

	if(document.querySelector('.menus-block.mobile')){
		let selectMenus = document.querySelector('.menus-block__dropdown #select_menus');
		let allMenus = document.querySelectorAll('.menus-block_list .menu');

		selectMenus.addEventListener('change',()=>{
			let valueMenu = selectMenus.value;
			allMenus.forEach((menus)=>{
				menus.classList.toggle('hidden', menus.dataset.menu != valueMenu);
			})
		});

		const eventChangeMenu = new Event('change');
		selectMenus.dispatchEvent(eventChangeMenu);

		allMenus.forEach((menu)=>{
			let selectCategories = menu.querySelectorAll('.menu__dropdown select');
			let allCategories = menu.querySelectorAll('.menu_category');

			selectCategories.forEach((select)=>{
				select.addEventListener('change',()=>{
					let valueCategory = select.value;		
					allCategories.forEach((category)=>{
						category.classList.toggle('hidden', category.dataset.category != valueCategory);
					})
				})
				select.dispatchEvent(eventChangeMenu);
			})
		})
	}

	//booking widget 
	if(document.querySelectorAll('.js-booking-trigger').length > 0){
		document.querySelector('.js-header-btn').addEventListener('click', () => {
			document.querySelector('.js-booking-container').classList.toggle('open');
		});
		document.querySelector('.js-booking-close').addEventListener('click', () => {
			document.querySelector('.js-booking-container').classList.toggle('open');
		});
		addBooking();
	}

    window.onload = function() {

		if(window.innerWidth < 600){
			checkPrimaryNavigation();			
		}

		if(document.querySelector('.no-hero-img') || document.querySelector('#attractions') || document.querySelector('#gallery-flex') || document.querySelector('#blogs-entry') ){
			document.querySelector('header').classList.add('down');
			document.querySelector('.js-header-logo').src = document.querySelector('.js-header-logo').dataset.scroll
		} else {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		if(document.querySelector('.js-menu-burger')){
			document.querySelector('.js-menu-burger').addEventListener('click', () => {
				document.querySelector('.js-menu-container').classList.add('open');
			})
		}
		if(document.querySelector('.js-menu-container_close')){
			document.querySelector('.js-menu-container_close').addEventListener('click', () => {
				document.querySelector('.js-menu-container').classList.remove('open');
			})
		}

	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
	
	// Click booking emulator
	const bookingButtons = document.querySelectorAll('.js-booking');
	const headerBookingBtn = document.querySelector('.js-header-btn');
	const externalUrl = "https://www.hilton.com/en/book/reservation/rooms/?_gl=1*1rcfpiq*_ga*MTgyOTAxODExLjE3Njg1ODA1ODA.*_ga_M9N1TPCH12*czE3NzE0MzE0ODkkbzQkZzEkdDE3NzE0MzI3NDckajQ2JGwwJGgw";

	if (bookingButtons.length) {
		bookingButtons.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();
				const isMobile = window.innerWidth <= 640;

				if (isMobile) {
					window.location.href = externalUrl;
				} else if (headerBookingBtn) {
					headerBookingBtn.click();
				}
			});
		});
}

})();
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
			(document.querySelector('.js-header-logo')) ? document.querySelector('.js-header-logo').src = document.querySelector('.js-header-logo').dataset.scroll : '';
			(document.querySelector('.js-header-logo') && !document.querySelector('.js-header-logo').classList.contains('scroll')) ? document.querySelector('.js-header-logo').classList.add('scroll') : '';
		}
		
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
			(document.querySelector('.js-header-logo')) ? document.querySelector('.js-header-logo').src = document.querySelector('.js-header-logo').dataset.original : '';
			(document.querySelector('.js-header-logo') && document.querySelector('.js-header-logo').classList.contains('scroll')) ? document.querySelector('.js-header-logo').classList.remove('scroll') : '';
		}
		
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//PRIMARY NAV 
document.addEventListener('DOMContentLoaded', () => {
    const primNav = document.querySelectorAll('.privary-navigation__item');

    primNav.forEach(item => {
        item.addEventListener('click', function(e) {

            e.stopPropagation();

            if (this.classList.contains('is-active')) {
                this.classList.remove('is-active');
            } else {
                primNav.forEach(el => el.classList.remove('is-active'));
                this.classList.add('is-active');
            }
        });
    });
    
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.privary-navigation__item')) {
            primNav.forEach(el => el.classList.remove('is-active'));
        }
    });
});